export default __webpack_public_path__ + "static/media/office-dark.1a5b950b.jpg";